import React from 'react';
import {useDispatch, useSelector} from "react-redux";
import agentsActions from "../../store/actions/agents";

const MapMarker = ({agentNumber, firstName, middleName, lastName, agency, lat, lng, id}) => {
    const agentsStore = useSelector((store) => store.agentsStore);
    const dispatch = useDispatch();
    const setActiveMarker = (id) => {
        dispatch(agentsActions.setActiveMarker(id));
        dispatch(agentsActions.setMapCenter({lat, lng}))
    }
    return (
        <div className={`map-marker ${agentsStore.activeMarker === id && 'open'}`}>
            <div className="map-marker-icon">
                <img className="map-marker-icon" src={`${process.env.REACT_APP_MY_API_KEY}rvos-graphics/assets/img/marker.svg`} alt="marker" onClick={() => setActiveMarker(id)}/>
                <div className="map-marker-icon__number">{agentNumber}</div>
            </div>
            <div className="map-marker-tooltip">
                <div className="map-marker-tooltip-name">
                    {firstName && (
                        <span>{firstName}</span>
                    )}
                    {middleName && (
                        <span> {middleName}</span>
                    )}
                    {lastName && (
                        <span> {lastName}</span>
                    )}
                </div>
                {agency && (
                    <div className="map-marker-tooltip-agency">
                        {agency}
                    </div>
                )}
                <a className="map-marker-link" href={`https://maps.google.com/?q=${lat},${lng}`} target="_blank">Get directions</a>
            </div>
        </div>
    )
};

export default MapMarker;

